import { render, staticRenderFns } from "./CookiePolicyWidget.vue?vue&type=template&id=3b0e2889&scoped=true&"
import script from "./CookiePolicyWidget.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyWidget.vue?vue&type=script&lang=js&"
import style0 from "./CookiePolicyWidget.vue?vue&type=style&index=0&id=3b0e2889&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e2889",
  null
  
)

export default component.exports